import { InstanceSkeleton } from 'features/instance-controller/ui/instance-skeleton';
import { Skeleton, type SkeletonVariant } from 'shared/ui/skeleton';
export const InstanceControllerSkeleton = ({
  variant
}: SkeletonVariant) => {
  return <div className="inline-flex flex-row items-end gap-2" data-sentry-component="InstanceControllerSkeleton" data-sentry-source-file="instance-controller-skeleton.tsx">
      <InstanceSkeleton variant={variant} data-sentry-element="InstanceSkeleton" data-sentry-source-file="instance-controller-skeleton.tsx" />
      <div>
        <Skeleton className="size-9" variant={variant} data-sentry-element="Skeleton" data-sentry-source-file="instance-controller-skeleton.tsx" />
      </div>
      <div>
        <Skeleton className="size-9 " variant={variant} data-sentry-element="Skeleton" data-sentry-source-file="instance-controller-skeleton.tsx" />
      </div>
      <div>
        <Skeleton className="size-9 " variant={variant} data-sentry-element="Skeleton" data-sentry-source-file="instance-controller-skeleton.tsx" />
      </div>
    </div>;
};